<template>
    <section>
        <h1 class="mt-5 mb-3 text-center">{{$t('results.header')}}</h1>

        <v-row>
            <v-col>
                <v-text-field
                        v-model="keyword"
                        :label="$t('global.search')"
                        hide-details
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-search'" size="15"></svg>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-data-table :headers="headers"
                      :items="RESULTS"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{props.index+1}}
            </template>

            <template v-slot:item.name_surname="props">
                {{props.item.user_name}} {{props.item.user_sur_name}}
            </template>

            <template v-slot:item.result="props">
                {{props.item.result}}%
            </template>

            <template v-slot:item.time="props">
                {{Math.ceil(props.item.time / 60)}} / {{props.item.time_total / 60}} {{$t('results.minutes')}}
            </template>

            <template v-slot:item.created_at="props">
                {{moment(props.item.created_at).locale(localeDate).format('lll')}}
            </template>

            <template v-slot:item.status="props">
                <span :class="getStatusClass(props.item.status)">
                    {{ getStatus(props.item.status) }}
                </span>
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0" :href="props.item.pdf_link" target="_blank" v-if="props.item.status !== 1 && props.item.status !== 3">
                    <svg v-svg="'icon-show'" size="15" class="mr-1"></svg>
                    <span class="show">{{$t('global.show')}}</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        data(){
            return {
                timeout: null,
                loadingRequest: false,
                keyword: null,
                headersStudent: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: this.$t('results.subject'), sortable: false, value: 'course_name'},
                    {text: this.$t('results.result'), sortable: false, value: 'result'},
                    {text: this.$t('results.cheated'), sortable: false, value: 'cheated'},
                    {text: this.$t('results.timeout'), sortable: false, value: 'time_out'},
                    {text: this.$t('results.skipped'), sortable: false, value: 'skipped'},
                    {text: this.$t('results.time'), sortable: false, value: 'time'},
                    {text: this.$t('results.date'), sortable: false, value: 'created_at'},
                    {text: this.$t('results.status'), sortable: false, value: 'status'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'center'}
                ],
                headersTeacher: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: this.$t('results.student'), sortable: false, value: 'name_surname'},
                    {text: this.$t('results.subject'), sortable: false, value: 'course_name'},
                    {text: this.$t('results.total'), sortable: false, value: 'total'},
                    {text: this.$t('results.result'), sortable: false, value: 'result'},
                    {text: this.$t('results.status'), sortable: false, value: 'status'},
                    {text: this.$t('students.team'), sortable: false, value: 'team_name'},
                    {text: this.$t('results.date'), sortable: false, value: 'created_at'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'center'}
                ],
            }
        },

        computed: {
            ...mapGetters(['RESULTS']),
            localeDate(){
                return this.$i18n.locale === 'am' ? 'hy-am' : 'en';
            },
            headers(){
                return this.hasRole('student') ? this.headersStudent : this.headersTeacher;
            }
        },

        mounted(){
            this.getData();
        },

        watch: {
            keyword() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.getData();
                }, 300);
            }
        },

        methods: {
            getData(){
                this.loadingRequest = true;
                if(this.hasRole('student')){
                    this.$store.dispatch('GET_STUDENT_RESULTS', {params: {keyword: this.keyword}})
                        .then(() => this.loadingRequest = false);
                }else{
                    this.$store.dispatch('GET_TEACHER_RESULTS', {params: {keyword: this.keyword}})
                        .then(() => this.loadingRequest = false);
                }
            },
            getStatus(id) {
                let statuses = [this.$t('results.passed'), this.$t('results.progress'), this.$t('results.failed'),this.$t('results.finished')];
                return statuses[id] || '';
            },
            getStatusClass(id) {
                let statuses = ["green--text", "orange--text", "red--text","green--text"];
                return statuses[id] || '';
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/tablePages";
</style>